import React from 'react';
export function CalculatorValueSection() {
  return <section className="mb-16 animate-on-scroll" data-id="element-110">
      <h2 className="text-[24px] md:text-[28px] font-bold mb-8 text-black text-center" data-id="element-111">
        What This Calculator Reveals
      </h2>
      <div className="bg-[#f0f9f4] border-l-4 border-[#00be60] p-6 rounded-r-lg shadow-sm mb-8" data-id="element-112">
        <ul className="space-y-4" data-id="element-113">
          <li className="text-[15px] md:text-[16px] text-black" data-id="element-114">
            Your exact cost per qualified seller lead through Meta ads vs.
            traditional channels
          </li>
          <li className="text-[15px] md:text-[16px] text-black" data-id="element-115">
            True broker cost analysis including fees + auction premiums +
            opportunity cost
          </li>
          <li className="text-[15px] md:text-[16px] text-black" data-id="element-116">
            ROI projections showing how deal multiples improve when you avoid
            auctions
          </li>
          <li className="text-[15px] md:text-[16px] text-black" data-id="element-117">
            Scalability metrics for building predictable deal flow in your
            market
          </li>
        </ul>
      </div>
    </section>;
}